var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { Bars } from '../../../../molecules/bars';
import { Container } from '../../../../templates/container';
import { IntensityGauge } from '../intensity-gauge';
var getMultipleOfFiveOverNumber = function (number) {
    return number % 5 !== 0 || number === 0 ? number + (5 - (number % 5)) : number;
};
var FP = function (_a) {
    var _b = _a.profiles, profiles = _b === void 0 ? [] : _b, _c = _a.showMultipleProfiles, showMultipleProfiles = _c === void 0 ? false : _c, _d = _a.fluid, fluid = _d === void 0 ? false : _d;
    var filteredProfiles = useMemo(function () {
        return profiles
            .map(function (_a) {
            var _b = _a.label, label = _b === void 0 ? '-' : _b, _c = _a.value, value = _c === void 0 ? 0 : _c, _d = _a.scale, scale = _d === void 0 ? getMultipleOfFiveOverNumber(value) : _d, info = _a.info;
            return ({ label: label, value: value, scale: scale, info: info });
        })
            .filter(function (_a) {
            var value = _a.value, scale = _a.scale;
            return !(Number.isNaN(value) || value > scale);
        });
    }, [profiles]);
    if (!(filteredProfiles === null || filteredProfiles === void 0 ? void 0 : filteredProfiles.length)) {
        return null;
    }
    return (React.createElement(Container, null, showMultipleProfiles ? (React.createElement(Bars, { fluid: fluid, profiles: filteredProfiles })) : (React.createElement(IntensityGauge, __assign({}, filteredProfiles[0])))));
};
export { FP as FlavourProfiles };
